/* Yool Icons · SVG stroke set 1.5px, round caps. No emoji, no icon libs. */

const BASE = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };

function Icon({ children, size = 16, style, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...BASE} style={style} {...rest}>
      {children}
    </svg>
  );
}

export const YIcon = {
  Building:     (p) => <Icon {...p}><path d="M4 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16M15 21V11h4a2 2 0 0 1 2 2v8M8 7h3M8 11h3M8 15h3M18 15h.01M18 18h.01M4 21h17"/></Icon>,
  User:         (p) => <Icon {...p}><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></Icon>,
  Plus:         (p) => <Icon {...p}><path d="M12 5v14M5 12h14"/></Icon>,
  Search:       (p) => <Icon {...p}><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4-4"/></Icon>,
  Refresh:      (p) => <Icon {...p}><path d="M21 12a9 9 0 1 1-3.5-7.1M21 4v5h-5"/></Icon>,
  Trash:        (p) => <Icon {...p}><path d="M4 7h16M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3M10 11v6M14 11v6"/></Icon>,
  Power:        (p) => <Icon {...p}><path d="M12 3v9"/><path d="M5.6 7.4a9 9 0 1 0 12.8 0"/></Icon>,
  Dots:         (p) => <Icon {...p}><circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/></Icon>,
  Mail:         (p) => <Icon {...p}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></Icon>,
  Phone:        (p) => <Icon {...p}><path d="M5 4h4l2 5-3 2a12 12 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></Icon>,
  Pin:          (p) => <Icon {...p}><path d="M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/></Icon>,
  Calendar:     (p) => <Icon {...p}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></Icon>,
  Shield:       (p) => <Icon {...p}><path d="M12 2l8 4v6c0 5-4 8-8 10-4-2-8-5-8-10V6l8-4z"/></Icon>,
  ExternalLink: (p) => <Icon {...p}><path d="M14 3h7v7M21 3l-9 9M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6"/></Icon>,
  FileText:     (p) => <Icon {...p}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></Icon>,
};
